import React from 'react'

import { Box, Typography } from "@mui/material"
import { USER_ROLE } from "Pages/Admin/Users/@constants"
import { dsColorNew } from "@palette"


export default function roleColumn() {

	return {
		name: 'role',
		label: 'Role',
		options: {
			customBodyRowRenderLite: value => <Box
				sx={{
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
				}}>
				<Typography sx={{
					borderBottom: "2px solid",
					borderColor: value === USER_ROLE.ADMIN ? dsColorNew.dangerRed : dsColorNew.appBlue,
					fontWeight: "bold"
				}}>
					{value}
				</Typography>
			</Box>
		}
	}
}